import React, { useRef } from "react";

export const OTPInput = ({ otp, setOtp }) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, index) => (
        <input
          key={index}
          type="tel" // Changed from type="text" to type="tel"
          inputMode="numeric" // Added to enforce numeric keyboard
          pattern="[0-9]*" // Added to enforce numeric input
          maxLength={1}
          ref={(ref) => (inputRefs.current[index] = ref)}
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className=" bg-white rounded-md border border-solid border-stone-200 h-[50px] w-[50px] text-center text-2xl font-bold"
          aria-label={`OTP digit ${index + 1}`}
        />
      ))}
    </div>
  );
};
